/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExtractRequest } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * ExtractTextApi - axios parameter creator
 * @export
 */
export const ExtractTextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint to extract property details from PropertyGuru URLs Supports both single listings and agent pages NOW SAVES DIRECTLY TO DATABASE using create_customer_data - No need for frontend to save!
         * @summary Extract Text
         * @param {ExtractRequest} extractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractText: async (extractRequest: ExtractRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extractRequest' is not null or undefined
            assertParamExists('extractText', 'extractRequest', extractRequest)
            const localVarPath = `/api/v1/extract-text/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExtractTextApi - functional programming interface
 * @export
 */
export const ExtractTextApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExtractTextApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint to extract property details from PropertyGuru URLs Supports both single listings and agent pages NOW SAVES DIRECTLY TO DATABASE using create_customer_data - No need for frontend to save!
         * @summary Extract Text
         * @param {ExtractRequest} extractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractText(extractRequest: ExtractRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractText(extractRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtractTextApi.extractText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExtractTextApi - factory interface
 * @export
 */
export const ExtractTextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExtractTextApiFp(configuration)
    return {
        /**
         * API endpoint to extract property details from PropertyGuru URLs Supports both single listings and agent pages NOW SAVES DIRECTLY TO DATABASE using create_customer_data - No need for frontend to save!
         * @summary Extract Text
         * @param {ExtractTextApiExtractTextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractText(requestParameters: ExtractTextApiExtractTextRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.extractText(requestParameters.extractRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for extractText operation in ExtractTextApi.
 * @export
 * @interface ExtractTextApiExtractTextRequest
 */
export interface ExtractTextApiExtractTextRequest {
    /**
     * 
     * @type {ExtractRequest}
     * @memberof ExtractTextApiExtractText
     */
    readonly extractRequest: ExtractRequest
}

/**
 * ExtractTextApi - object-oriented interface
 * @export
 * @class ExtractTextApi
 * @extends {BaseAPI}
 */
export class ExtractTextApi extends BaseAPI {
    /**
     * API endpoint to extract property details from PropertyGuru URLs Supports both single listings and agent pages NOW SAVES DIRECTLY TO DATABASE using create_customer_data - No need for frontend to save!
     * @summary Extract Text
     * @param {ExtractTextApiExtractTextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtractTextApi
     */
    public extractText(requestParameters: ExtractTextApiExtractTextRequest, options?: RawAxiosRequestConfig) {
        return ExtractTextApiFp(this.configuration).extractText(requestParameters.extractRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

